import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../../lib/router/withRouter';
import { message } from 'antd';
import RemoteImageReferralDetailWrap from '../../../views/remoteImage/referral/detail/RemoteImageReferralDetailWrap';
import { remoteImageActions } from '../../../store/modules/remoteImage';
import { REMOTE_IMAGE_REFERRAL_DETAIL_MODEL } from '../../../store/modules/remoteImage/models';
import {
  REMOTE_IMAGE_DETAIL_PAGE_TYPE,
  REMOTE_REFERRAL_IMAGE_TYPE,
  REMOTE_IMAGE_ACTIVE_STATUS_TYPE,
  REMOTE_IMAGE_TYPE,
  REMOTE_IMAGE_TYPE_TEXT,
} from '../../../constants/service/app/remoteImageConstants';
import { asyncSimpleModal } from '../../../lib/common';
import { remoteImageActiveConfirm, remoteImageInActiveConfirm } from '../../../lib/utils/RemoteImageUtils';

class RemoteImageReferralDetailContainer extends Component {
  componentDidMount() {
    const { match } = this.props;

    if (match.params.id) {
      this.initiate(Number(match.params.id));
    }
  }

  componentWillUnmount() {
    const { setData } = this.props;

    /**
     *  데이터 초기화
     */
    setData({
      path: ['remoteImageReferralDetail'],
      value: REMOTE_IMAGE_REFERRAL_DETAIL_MODEL,
    });
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = (remoteImageId) => {
    const { getRemoteImageReferralDetail } = this.props;

    getRemoteImageReferralDetail({
      remoteImageId,
    });
  };

  onSubmit = async () => {
    const { match, detailPageType, remoteImageReferralDetail, createRemoteImageReferral, editRemoteImageReferral } =
      this.props;
    const { exposeLocationType, linkType, appImg, pcImg, tabletImg, mobileImg, memo, status, originStatus } =
      remoteImageReferralDetail;

    if (!appImg.length || !pcImg.length || !tabletImg.length || !mobileImg.length) {
      message.error('이미지는 필수 값 입니다.');
      return;
    }

    let confirmResult = true;

    if (detailPageType === REMOTE_IMAGE_DETAIL_PAGE_TYPE.CREATE) {
      confirmResult = await asyncSimpleModal({
        type: 'confirm',
        title: '정보 확인',
        message: '원격이미지를 등록하시겠습니까?',
      });
    }

    if (!confirmResult) return;

    /**
     *  첨부파일 타입 추가
     */
    appImg[0].type = REMOTE_REFERRAL_IMAGE_TYPE.APP;
    pcImg[0].type = REMOTE_REFERRAL_IMAGE_TYPE.PC;
    tabletImg[0].type = REMOTE_REFERRAL_IMAGE_TYPE.TABLET;
    mobileImg[0].type = REMOTE_REFERRAL_IMAGE_TYPE.MOBILE;

    /**
     *  원격 이미지 등록
     */
    if (detailPageType === REMOTE_IMAGE_DETAIL_PAGE_TYPE.CREATE) {
      /**
       *  활성 상태인 경우 확인 모달 노출
       */
      if (status === REMOTE_IMAGE_ACTIVE_STATUS_TYPE.ACTIVE) {
        confirmResult = await remoteImageActiveConfirm({
          remoteImageTypeName: REMOTE_IMAGE_TYPE_TEXT[REMOTE_IMAGE_TYPE.REFERRAL],
        });
      }

      /**
       *  확인 모달에서 취소할 경우
       *  등록 중지
       */
      if (!confirmResult) return;

      createRemoteImageReferral({
        exposeLocationType,
        linkType,
        appImg,
        pcImg,
        tabletImg,
        mobileImg,
        memo,
        status,
      });
    } else if (detailPageType === REMOTE_IMAGE_DETAIL_PAGE_TYPE.EDIT) {
      /**
       *  원격 이미지 수정
       */
      /**
       *  상태가 변경된 경우
       */
      if (originStatus !== status) {
        /**
         *  비활성 -> 활성
         */
        if (status === REMOTE_IMAGE_ACTIVE_STATUS_TYPE.ACTIVE) {
          confirmResult = await remoteImageActiveConfirm({
            remoteImageTypeName: REMOTE_IMAGE_TYPE_TEXT[REMOTE_IMAGE_TYPE.REFERRAL],
          });
        } else if (status === REMOTE_IMAGE_ACTIVE_STATUS_TYPE.IN_ACTIVE) {
          /**
           *  활성 -> 비활성
           */
          confirmResult = await remoteImageInActiveConfirm({
            remoteImageTypeName: REMOTE_IMAGE_TYPE_TEXT[REMOTE_IMAGE_TYPE.REFERRAL],
          });
        }
      }

      /**
       *  확인 모달에서 취소할 경우
       *  편집 중지
       */
      if (!confirmResult) return;

      editRemoteImageReferral({
        remoteImageId: match.params.id ? Number(match.params.id) : undefined,
        memo,
        exposeLocationType,
        linkType,
        appImg,
        pcImg,
        tabletImg,
        mobileImg,
        status: originStatus !== status ? status : originStatus,
      });
    }
  };

  /**
   *  url 복사하기
   */
  copyUrl = (url) => {
    navigator.clipboard.writeText(url);
    message.success('복사가 완료되었습니다.');
  };

  render() {
    const { detailPageType, remoteImageReferralDetail, setData } = this.props;

    return (
      <RemoteImageReferralDetailWrap
        detailPageType={detailPageType}
        remoteImageReferralDetail={remoteImageReferralDetail}
        setData={setData}
        onSubmit={this.onSubmit}
        copyUrl={this.copyUrl}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    remoteImageReferralDetail: state.remoteImage.remoteImageReferralDetail,
  };
};

const mapDispatchToProps = {
  setData: remoteImageActions.setData,
  getRemoteImageReferralDetail: remoteImageActions.getRemoteImageReferralDetail,
  createRemoteImageReferral: remoteImageActions.createRemoteImageReferral,
  editRemoteImageReferral: remoteImageActions.editRemoteImageReferral,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RemoteImageReferralDetailContainer));
